import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import MundEagleLabs from "../icons/MundEagleLabs";
import EagleLabsIcon from "../icons/EagleLabs";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { useTranslation } from "react-i18next";

export default function EagleLabs() {
  const { t } = useTranslation("common");
  return (
    <IntegrationTable
      integrationKey="eagle_labs"
      title="Eagle Labs"
      main_icon={<MundEagleLabs />}
      icon={<EagleLabsIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.secret_token,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        active_statuses: ["paid", "refunded"],
        // TO DO - ChangeBack in active_statuses
      }}
      fieldLabels={{
        access_token: t("label_api_user"),
        placeholder_access_token: t("placeholder_api_user"),
        secret_token: t("label_api_key"),
        placeholder_secret_token: t("placeholder_api_key"),
      }}
    />
  );
}
